import { KnowledgeBaseSnippetKind } from 'types'
import GeneralIcon from './components/icons/GeneralIcon'
import CompanyInfoIcon from './components/icons/CompanyInfoIcon'
import ProductOrServiceIcon from './components/icons/ProductOrServiceIcon'
import AudienceIcon from './components/icons/AudienceIcon'
import KeywordsIcon from './components/icons/KeywordsIcon'
import AvoidListIcon from './components/icons/AvoidListIcon'

export const SnippetKindLayout: {
  [key in KnowledgeBaseSnippetKind]: {
    description: string
    title: string
    color: string
    icon: typeof GeneralIcon
  }
} = {
  [KnowledgeBaseSnippetKind.General]: {
    description: 'Save prompts that you frequently use for easy access.',
    title: 'General',
    color: '#dfe1e5',
    icon: GeneralIcon,
  },
  [KnowledgeBaseSnippetKind.CompanyInfo]: {
    description: 'Add details about your company, team, history or achievements.',
    title: 'Company Info',
    color: '#D0F8F3',
    icon: CompanyInfoIcon,
  },
  [KnowledgeBaseSnippetKind.ProductOrServiceDescription]: {
    description: 'Add details about a new product or service.',
    title: 'Product/Service Description',
    color: '#cdf0ff',
    icon: ProductOrServiceIcon,
  },
  [KnowledgeBaseSnippetKind.Audience]: {
    description: 'Add details about who you are speaking to.',
    title: 'Audience',
    color: '#fff1dc',
    icon: AudienceIcon,
  },
  [KnowledgeBaseSnippetKind.Keywords]: {
    description: 'Add keywords or hashtags you want Blaze to reference',
    title: 'Keywords',
    color: '#ebdcff',
    icon: KeywordsIcon,
  },
  [KnowledgeBaseSnippetKind.AvoidList]: {
    description: 'Add words that you want Blaze to avoid or omit.',
    title: 'Avoid List',
    color: '#ffcbcb',
    icon: AvoidListIcon,
  },
}
